import {
  FDContentContainer,
  FDStack, FDTextButton,
} from '@facet-wealth/design';
import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import useMobileLayout from 'Hooks/useMobileLayout';
import Footer from 'Components/ClientApp/Desktop/Footer';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { dataAttrs } from 'Helpers/Testing';
import fr from 'facet-rest';
import { ImageRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/ImageRel';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

const useStyles = buildUseStyles('ReferralPage', () => ({
  footer: {
    position: 'sticky',
    transform: 'initial',
    bottom: 'unset',
  },
  wrapText: {
    wordWrap: 'break-word',
  },
}));

export const Layout = () => {
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();
  const classes = useStyles();
  const { loadPageContentLink } = usePageContentContext();

  useBoneBackgroundColor();

  return (
    <>
      <FDContentContainer maxWidth={'xl'}>
        {
          resource.withRelationship(fr.relationships.taxFilingPartnerPage.name, (rel) => {
            return <FDTextButton onClick={() => loadPageContentLink(rel.link('related'))} label={'File taxes'} />;
          }, () => null)
        }
        <FDStack direction={isMobile ? 'column' : 'row'} spacing={4} paddingY={isMobile ? 4 : 8} wrap>
          <FDStack direction={'column'} spacing={3} flex={4} width={'100%'}>
            <FDStack direction={'column'} alignItems={'center'} spacing={2}>
              <MetaControlField attr={'title'} {...dataAttrs('tax waitlist page title')} />
              <MetaControlField attr={'subtitle'} {...dataAttrs('tax waitlist page subtitle')} />
              {
                  isMobile ? (
                    <ImageRel relationship={resource.relationship(fr.relationships.imageMobile.name)} />
                  ) : (
                    <ImageRel relationship={resource.relationship(fr.relationships.image.name)} />
                  )
                }
            </FDStack>
          </FDStack>
        </FDStack>
      </FDContentContainer>
      {!isMobile && <Footer className={classes.footer} />}
    </>
  );
};
